module.exports = __webpack_public_path__ + "img/seafirmsfircover_sample.6be00449.png";